<template>
  <div>
    <div
      :style="{ height: height }"
      class="collect-cards-coupons"
      :class="[handleCouponBg(item), styleType]"
      v-for="(item, index) in awardList"
      :key="index">
      <!-- 积分券 -->
      <template v-if="item.itemCode === '0'">
        <div class="collect-coupon-type point-top-1000">
          <span class="coinQty">{{ item.coinQty }}</span><br/>易加网积分
        </div>
        <img class="collect-coupon-exchanged" src="@/assets/images/activity/collect-cards/coupon-exchanged.png"
          alt="exchanged">
        <span class="collect-coupon-pointTip">赠送积分已到您的账户，请在到期前使用</span>
      </template>
      <!-- 满减券/礼品券 -->
      <div class="collect-coupon-type" v-else>
        <div v-if="item.couponDTO && item.couponDTO.couponType === '02'">积分券</div>
        <div v-else>礼品券</div>
      </div>
      <span class="collect-coupon-name">{{ item.itemName }}</span>
      <span class="collect-coupon-date">{{ item.endDate|| (item.couponDTO && item.couponDTO.expireDate) |
        parseTime('{y}-{m}-{d}') }}前可用</span>

      <van-button
        class="collect-coupon-button"
        v-if="userRole !== '03' && item.itemCode !== '0' && item.couponDTO && item.couponDTO.couponType === '03' && item.couponDTO.couponStatus !== '03'"
        :color="item.itemCode !== '0' ? '#5696A0' : '#FF8F3D'"
        :size="styleType"
        :disabled="item.couponDTO && item.couponDTO.couponStatus === '03'"
        @click="directBuy(item.couponDTO)" >
        免费领取</van-button>
        <span class="collect-coupon-count" v-if="showCount">x{{ item.count }}</span>
    </div>
  </div>
</template>

<script>
import cartApi from '@/api/cart'
export default {
  components: {},
  props: {
    awardList: {
      type: Array,
      default: () => {
        return []
      }
    },
    height: {
      type: String,
      default: '100px'
    },
    styleType: {
      type: String,
      default: 'mini'
    },
    showCount: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      userRole: ''
    }
  },
  computed: {
  },
  mounted () {
    this.userRole = JSON.parse(localStorage.getItem('userInfo')).clientInfo.clientUserDTO.userRole
  },
  methods: {
    // 使用卡券
    directBuy (coupon) {
      const payload = {
        itemQuantity: 1,
        itemId: coupon.limitItemId,
        couponId: coupon.couponId
      }
      cartApi.queryCartBuy(payload).then(res => {
        if (res.data.resultCode === '0') {
          this.$router.push({
            name: 'direct_buy',
            query: {
              itemId: coupon.limitItemId,
              couponId: coupon.couponId
            }
          })
        }
      })
    },
    // 卡券背景图
    handleCouponBg (item) {
      if (item.itemCode === '0') {
        return 'collect-coupon-point'
      } else {
        if (item.couponDTO && item.couponDTO.couponStatus === '02') {
          if (item.couponDTO && item.couponDTO.couponType === '02') {
            // 满减券
            return 'collect-coupon-reduction'
          } else {
            return 'collect-coupon-gift'
          }
        } else if (item.couponDTO && item.couponDTO.couponStatus === '03') {
          return 'collect-coupon-used'
        } else {
          return 'collect-coupon-point'
        }
      }
    }
  }
}
</script>
<style lang='less' scoped>
.small {
  .collect-coupon-type {
    font-size: 18px !important;
    .coinQty{
      font-size: 24px !important;
    }
  }

  .collect-coupon-name {
    font-size: 16px !important;
  }

  .collect-coupon-date {
    font-size: 12px !important;
  }
  .collect-coupon-pointTip {
    font-size: 12px !important;
  }
}

.collect-cards-coupons {
  +.collect-cards-coupons {
    margin-top: 10px;
  }
}
.point-top-1000{
  top:24% !important;
}
::v-deep .van-button--mini{
  height: 20px;
}
::v-deep .van-button{
  box-shadow: 0 10px 15px -3px rgba(0,0,0,0.1),0 4px 6px -2px rgba(0,0,0,0.05);
}
</style>
